import { getIkeaFamilyStatus, getPartyUId, getRetailUnit } from './jwt';

export type Token = {
  value: string;
  expirationTime: number;
};
export type Tokens = {
  auth?: Token;
  guest?: Token;
};

type User = {
  uid: string;
  guest: boolean;
  token: string;
  isFamilyMember: boolean;
  retailUnit: string;
};

// Prefers logged in tokens, falls back to guest token
export const pickToken = ({ auth, guest }: Tokens): User => {
  if (auth && auth.value) {
    return {
      uid: getPartyUId(auth.value),
      token: auth.value,
      guest: false,
      isFamilyMember: getIkeaFamilyStatus(auth.value),
      retailUnit: getRetailUnit(auth.value),
    };
  }

  return {
    uid: getPartyUId(guest?.value),
    token: guest?.value || '',
    guest: true,
    isFamilyMember: false,
    retailUnit: getRetailUnit(guest?.value),
  };
};

export const getTokens = (): Promise<Tokens> => {
  return new Promise<Tokens>((resolve, reject) => {
    const callback = (error: any, newTokens: Tokens) => {
      if (error) {
        reject(error);
      }
      resolve(newTokens);
    };

    if (window.ikea && window.ikea.authentication) {
      window.ikea.authentication.getTokens(callback);
    } else {
      reject('ikea.authentication is missing');
    }
  });
};
